import React, { ReactNode, memo, useEffect, useState } from "react";

type FontWrapperProps = {
	item: {
		id: string;
		file: {
			data: Blob;
			type: string;
		};
		name: string;
	};
	children: ReactNode;
};

const FontWrapper = ({ item, children }: FontWrapperProps) => {
	const [fontUrl, setFontUrl] = useState<string>("");

	useEffect(() => {
		const url = URL.createObjectURL(item.file.data);
		setFontUrl(url);

		return () => {
			URL.revokeObjectURL(url);
		};
	}, [item.file.data]);

	return (
		<span
			id={`Div-${item.id}`}
			style={{ fontFamily: item.id }}
			className="select-none capitalize"
		>
			<style>{`
				@font-face {
					font-family: '${item.id}';
					src: url(${fontUrl});
					font-weight: normal;
					font-style: normal;
				}
			`}</style>
			{children}
		</span>
	);
};

export default memo(FontWrapper);